import { useMutation, useQueryClient } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'
import { DynamoDBItemUpdate } from 'types'

const updateItems = async ({ updates }: { updates: DynamoDBItemUpdate[] }) => {
  if (!updates?.length) throw new Error('No updates provided')

  const url = `${baseUrl}/aws/batch/updateitems`
  const response = await axios.put(url, { updates })
  if (response.status !== 200) throw new Error('Failed to update items')
  return response.data
}

export const useBatchUpdateItems = (invalidateKeys: string[] = []) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateItems,
    onSuccess: (data, _variables) => {
      console.log('[✅ useBatchUpdateItems] Update success:', data)
      queryClient.invalidateQueries({ queryKey: invalidateKeys })
      // const affectedKeys = new Set<string>()
      // variables.updates.forEach(u => affectedKeys.add(u.tableName))
      // invalidateKeys.forEach(k => affectedKeys.add(k))

      // affectedKeys.forEach(key => {
      //   queryClient.invalidateQueries({ queryKey: [key] })
      // })
    },
    onError: error => {
      console.error('[❌ useBatchUpdateItems] Error during update:', error)
    },
  })
}
